const office = [
  { value: 1, label: 'Vendedor' },
  { value: 2, label: 'Coordenador' },
  { value: 998, label: 'Lider' },
  { value: 999, label: 'GO' },
  { value: 3, label: 'GerenteTrilha' },
  { value: 4, label: 'GerenteGeral' },
  { value: 5, label: 'DiretorVendas' },
  { value: 6, label: 'DiretorComercialMKTConcreto' },
];

export default office;
